export const getOfferDDActionName = (position: number) => `Offer-${position}`
